import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import Header from './header'
import './layout.css'
import Image from './image'
import Footer from './footer'

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: 'description', content: 'Organizing meal planning can be fun! See what your Facebook friends are making for dinner. Stay organized and save time with your tried and true recipes.' },
            { name: 'keywords', content: 'meal plan,recipe,organization' },
            { name: 'google-site-verification', content: '15djuHcqWsuypdgfMDvXtizw6vPCjg5VYzbZ5-4UnRU' },
          ]}
        >
          <html lang="en" />
        </Helmet>
        <Header siteTitle={<Image />} />
        <div
          style={{
            margin: '0 auto',
            maxWidth: 960,
            padding: '0px 1.0875rem',
            paddingTop: 0,
          }}
        >
          {children}
        </div>
        <Footer />
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
